export const allowedStates = ['NJ', 'NY', 'PA', 'CT', 'MD', 'CA', 'FL'];
